import { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { genericSearch } from "services/common";
import UserAssets from "../UserAssets/UserAssets";
import { useTranslation } from "react-i18next";
import Pagination from "../Pagination/Pagination";
import _ from "lodash";
import { Icon, Loader } from "semantic-ui-react";

const AssetSelectionCarousel = ({
  assets,
  maxNumberOfAssets,
  isNewAssetLoading,
  handleSetClickedAssetId,
}) => {
  const { t } = useTranslation("common");
  const [initialAssets, setInitialAssets] = useState(assets);
  const [carouselCurrentSlide, setCarouselCurrentSlide] = useState(0);
  const [isSearching, setIsSearching] = useState(false);

  const { oldAssetsSearchCriteria } = useSelector((state) => state.deliveries);

  const oldAssetsCarousel = useMemo(() => {
    const carouselItemsLength = Math.floor(Math.abs(initialAssets.length / maxNumberOfAssets) + 1);
    const assetsSlice = Array.from(
      Array(carouselItemsLength),
      (x, index) => 0 + index * maxNumberOfAssets
    );
    const oldAssetsCarouselTemp = [];
    for (let i = 0; i < assetsSlice.length; i++) {
      let superiorLimit =
        assetsSlice[i] + maxNumberOfAssets < initialAssets.length
          ? assetsSlice[i] + maxNumberOfAssets
          : initialAssets.length;
      oldAssetsCarouselTemp.push(initialAssets.slice(assetsSlice[i], superiorLimit));
    }
    const results = oldAssetsCarouselTemp.filter((arr) => (arr.length === 0 ? false : true));
    return results;
  }, [initialAssets, maxNumberOfAssets]);

  useEffect(() => {
    setInitialAssets(assets);
    oldAssetsSearchCriteria &&
      oldAssetsSearchCriteria !== "" &&
      setInitialAssets(genericSearch(assets, oldAssetsSearchCriteria));
  }, [assets]);

  useEffect(() => {
    if (oldAssetsSearchCriteria && oldAssetsSearchCriteria !== "") setIsSearching(true);
    const timer = setTimeout(() => {
      setIsSearching(false);
    }, 1000);
    oldAssetsSearchCriteria && oldAssetsSearchCriteria !== ""
      ? setInitialAssets(genericSearch(assets, oldAssetsSearchCriteria))
      : setInitialAssets(assets);
    setCarouselCurrentSlide(0);
    return () => clearTimeout(timer);
  }, [oldAssetsSearchCriteria]);

  const handlePaginationChange = (actualPage) => {
    setCarouselCurrentSlide(parseInt(actualPage) - 1);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "67vh",
        }}
        className={isNewAssetLoading ? "loading-asset" : ""}
      >
        {initialAssets.length > 0 ? (
          <>
            <div key={_.uniqueId("carouselpage_")} className="asset-cards-container">
              {isSearching || isNewAssetLoading ? (
                <Loader inverted inline="centered" active={isSearching}>
                  Searching
                </Loader>
              ) : (
                <>
                  {initialAssets.length > maxNumberOfAssets && (
                    <div
                      style={{
                        display: "flex",
                        position: "absolute",
                        top: "50%",
                        left: "0",
                        zIndex: "2",
                        width: "100%",
                        justifyContent: "space-between",
                        fontSize: "45px",
                      }}
                    >
                      <Icon
                        name="angle left"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          pointerEvents: `${carouselCurrentSlide === 0 ? "none" : "auto"}`,
                        }}
                        disabled={carouselCurrentSlide === 0}
                        onClick={() => setCarouselCurrentSlide(carouselCurrentSlide - 1)}
                      />
                      <Icon
                        name="angle right"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          justifyContent: "end",
                          pointerEvents: `${
                            carouselCurrentSlide === oldAssetsCarousel.length - 1 ? "none" : "auto"
                          }`,
                        }}
                        disabled={carouselCurrentSlide === oldAssetsCarousel.length - 1}
                        onClick={() => setCarouselCurrentSlide(carouselCurrentSlide + 1)}
                      />
                    </div>
                  )}
                  <UserAssets
                    assets={oldAssetsCarousel[carouselCurrentSlide]}
                    isNewAssetLoading={isNewAssetLoading}
                    handleSetClickedAssetId={(assetId) => handleSetClickedAssetId(assetId)}
                    t={t}
                  />
                </>
              )}
            </div>
            {initialAssets.length > maxNumberOfAssets && (
              <Pagination
                pointing
                secondary
                activePage={carouselCurrentSlide + 1}
                siblingRange={1}
                showEllipsis={true}
                showFirstAndLastNav={true}
                showPreviousAndNextNav={true}
                totalPages={oldAssetsCarousel.length}
                handlePaginationChange={handlePaginationChange}
                horizontalPosition={"center"}
                verticalPosition={"left"}
              />
            )}
          </>
        ) : oldAssetsSearchCriteria && oldAssetsSearchCriteria ? (
          <div
            className="asset-cards-container"
            style={{ marginBottom: "1rem", textAlign: "center" }}
          >
            <p style={{ textAlign: "center" }}>{t("campaign_search_no_results")}</p>
          </div>
        ) : (
          <p>{t("campaign_search_no_assets")}</p>
        )}
      </div>
    </>
  );
};

export default AssetSelectionCarousel;
